// @flow
import React from "react";
import TrustPilot from "../../svg/trustpilot.svg";

import "./trustPilotStars.scss";

type Props = {
  rating: "4" | "4.5" | "5"
};

const baseClass = "trustpilot_svg__tp-stars";

const getClassName = (string) => {
  if (string === "5") {
    return `${baseClass}--5`;
  }

  if (string === "4.5") {
    return `${baseClass}--4 ${baseClass}--4--half`;
  }

  return `${baseClass}--4`;
};

const TrustPilotStars = ({ rating }: Props) => {
  const ratingClass = getClassName(rating);

  return (
    <div className={`${ratingClass} ${baseClass}`}>
      <TrustPilot />
    </div>
  );
};

export default TrustPilotStars;
